export const mentionLimit = 20
export const maxMessageLength = 500